import React from 'react';
import { TextField } from '@/shared/components/TextField';
import { SUBSCRIPTION_MANAGEMENT_LABELS } from '@/epics/subscriptionManagment/constants/translations/labels';
import {
  formatPriceWithSpaces,
  isPriceTooBig,
  MAX_PRICE_LENGTH,
} from '@/epics/subscriptionManagment/hooks/useCreateSubscription';

export interface EquipmentCategoryPriceRowProps {
  categoryId: string;
  categoryLabel: string;
  basePrice: string;
  onBasePriceChange: (value: string) => void;
  error?: string | undefined;
  disabled?: boolean;
}

/** One row of the Equipment Pricing step: category label and its base price. */
export const EquipmentCategoryPriceRow: React.FC<
  EquipmentCategoryPriceRowProps
> = ({
  categoryId,
  categoryLabel,
  basePrice,
  onBasePriceChange,
  error,
  disabled = false,
}) => {
  return (
    <div
      data-field={`equipment-price-${categoryId}`}
      className="grid grid-cols-2 items-center"
    >
      <span
        style={{
          color: 'var(--Schemes-On-Surface-Variant, #474A4C)',
          fontSize: 18,
          fontFamily: 'Roboto',
          fontWeight: '400',
          lineHeight: '26px',
          wordWrap: 'break-word',
        }}
      >
        {categoryLabel}
      </span>
      <div className="flex flex-col gap-1">
        <TextField
          label={SUBSCRIPTION_MANAGEMENT_LABELS.FIELD_BASE_PRICE.polish}
          type="amount"
          width={320}
          maxLength={MAX_PRICE_LENGTH}
          value={formatPriceWithSpaces(basePrice)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\s/g, '');
            if (isPriceTooBig(raw)) {
              return;
            }
            onBasePriceChange(raw);
          }}
          error={!!error}
          errorMessage={error ?? ''}
          disabled={disabled}
          trailingIcon={
            basePrice ? (
              <span className="text-bodyLarge text-neutral-10 align-middle ml-[2px] mt-[12px]">
                zł
              </span>
            ) : null
          }
        />
      </div>
    </div>
  );
};

export default EquipmentCategoryPriceRow;
